import { CatHeading } from '@blocks-react/components/Heading';
import { EquipmentInfoProps } from '../types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { capitalizeText } from '../utils';

export const RequestServiceEquipmentInfo = ({
  equipmentModel,
  equipmentFamily,
  serialNumber,
  nickName
}: EquipmentInfoProps) => {
  return (
    <>
      <CatTooltip position="top">
        <CatHeading variant="display-sm" slot="trigger">
          {nickName ? `${nickName} | ` : ''} {equipmentModel}{' '}
          {capitalizeText(equipmentFamily)}
        </CatHeading>
        <p>
          {nickName ? `${nickName} | ` : ''} {equipmentModel}{' '}
          {capitalizeText(equipmentFamily)}
        </p>
      </CatTooltip>
      <CatHeading variant="body-sm">{serialNumber}</CatHeading>
    </>
  );
};
